import { RecentlyViewed } from '@theme/recently-viewed-products';

function formatMoney(amount) {
  var value = Number(amount);
  if (Number.isNaN(value)) return '';
  return (
    'Rs.' +
    value.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  );
}

function buildCard(product) {
  var li = document.createElement('li');
  li.className = 'recently-viewed__card';

  var link = document.createElement('a');
  link.className = 'recently-viewed__card-image-wrapper';
  link.href = product.url;

  if (product.featured_image && product.featured_image.url) {
    var img = document.createElement('img');
    img.src = product.featured_image.url;
    img.alt = product.featured_image.alt || product.title;
    img.loading = 'lazy';
    link.appendChild(img);
  }

  var title = document.createElement('a');
  title.className = 'recently-viewed__card-title';
  title.href = product.url;
  title.textContent = product.title;

  var priceRow = document.createElement('div');
  var price = document.createElement('span');
  price.className = 'recently-viewed__card-price';
  price.textContent = formatMoney(product.price);
  priceRow.appendChild(price);

  if (product.compare_at_price_max > product.price) {
    var compareAt = document.createElement('span');
    compareAt.className = 'recently-viewed__card-compare-price';
    compareAt.textContent = formatMoney(product.compare_at_price_max);
    priceRow.appendChild(compareAt);
  }

  li.appendChild(link);
  li.appendChild(title);
  li.appendChild(priceRow);

  return li;
}

async function renderRecentlyViewed(container) {
  var viewed = RecentlyViewed.getProducts();
  var currentProductId = container.getAttribute('data-current-product-id');
  var maxProducts = parseInt(container.getAttribute('data-max-products'), 10) || 4;

  viewed = viewed.filter(function (id) {
    return String(id) !== String(currentProductId);
  });

  if (!viewed.length) return;

  var query = viewed
    .slice(0, maxProducts)
    .map(function (id) {
      return 'id:' + id;
    })
    .join(' OR ');

  var url = new URL('/search/suggest.json', window.location.origin);
  url.searchParams.set('q', query);
  url.searchParams.set('resources[type]', 'product');
  url.searchParams.set('resources[limit]', String(maxProducts));

  try {
    var response = await fetch(url.toString());
    if (!response.ok) return;

    var data = await response.json();
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];

    if (!products.length) return;

    var order = viewed;
    products.sort(function (a, b) {
      return order.indexOf(String(a.id)) - order.indexOf(String(b.id));
    });

    var grid = container.querySelector('.recently-viewed__grid');
    grid.innerHTML = '';
    products.forEach(function (product) {
      grid.appendChild(buildCard(product));
    });

    container.hidden = false;
  } catch (error) {
    // Silently fail — recently viewed is a non-critical enhancement.
  }
}

function init() {
  document.querySelectorAll('.recently-viewed').forEach(renderRecentlyViewed);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
